<div class="dna-heranca" *ngIf="temDna; else semDna">
  <header class="dna-heranca__header">
    <span class="dna-heranca__simbolo">
      <img *ngIf="dna.imagemUrl; else iconeDna" [src]="dna.imagemUrl" alt="" />
      <ng-template #iconeDna>
        <i [class]="dna.icone || 'fas fa-dna'" aria-hidden="true"></i>
      </ng-template>
    </span>

    <div class="dna-heranca__identidade">
      <p class="dna-heranca__rotulo">Herdado do DNA</p>
      <p class="dna-heranca__nome">{{ dna.nome }}</p>
    </div>

    <div class="dna-heranca__acoes">
      <button
        *ngIf="podeEditar"
        type="button"
        class="dna-heranca__botao"
        (click)="trocar.emit()"
      >
        <i class="fas fa-exchange-alt" aria-hidden="true"></i> Trocar
      </button>
      <button
        *ngIf="podeEditar"
        type="button"
        class="dna-heranca__botao dna-heranca__botao--neutro"
        (click)="desvincular.emit()"
      >
        <i class="fas fa-unlink" aria-hidden="true"></i> Desvincular
      </button>
      <button type="button" class="dna-heranca__botao" (click)="onAbrirDna()">
        <i class="fas fa-external-link-alt" aria-hidden="true"></i> Ver DNA
      </button>
    </div>
  </header>

  <p class="dna-heranca__explicacao">
    <i class="fas fa-info-circle" aria-hidden="true"></i>
    <span>
      Estes parâmetros vêm da família e valem para todos os SKUs do DNA. As projeções mostradas
      são <strong>as do DNA</strong> — quando este SKU sobrescreve um parâmetro, a linha aparece
      marcada como <strong>mutação</strong> e a expectativa deste produto passa a ser distinta.
    </span>
  </p>

  <ul class="dna-heranca__lista">
    <li
      class="dna-heranca__linha"
      *ngFor="let linha of linhas; trackBy: trackByNumero"
      [class.dna-heranca__linha--mutacao]="linha.mutacao"
    >
      <div class="dna-heranca__linha-identificacao">
        <span class="dna-heranca__linha-numero">{{ linha.numero }}</span>
        <span class="dna-heranca__linha-label">{{ linha.label }}</span>
        <span class="dna-heranca__badge" *ngIf="linha.mutacao">
          <i class="fas fa-code-branch" aria-hidden="true"></i> mutação
        </span>
      </div>

      <div class="dna-heranca__linha-valores">
        <span class="dna-heranca__valor-herdado" *ngIf="linha.valorHerdado">
          {{ linha.valorHerdado }}
        </span>
        <span class="dna-heranca__valor">{{ linha.valor }}</span>
        <span
          class="dna-heranca__projecao"
          *ngIf="linha.projecao || linha.projecaoMedindo"
          [class.dna-heranca__projecao--medindo]="linha.projecaoMedindo"
        >
          <i
            *ngIf="linha.projecaoMedindo"
            class="fas fa-circle-notch fa-spin"
            aria-hidden="true"
          ></i>
          {{ linha.projecao }}{{ linha.projecao && linha.mutacao ? ' (deste SKU)' : '' }}
        </span>
      </div>
    </li>
  </ul>

  <p class="dna-heranca__rodape" *ngIf="temMutacao">
    <i class="fas fa-code-branch" aria-hidden="true"></i>
    <span>
      A mutação de {{ parametrosMutados }} vale só para este SKU — a família continua com os
      valores do DNA. Editar o DNA não desfaz a mutação.
    </span>
  </p>
</div>

<ng-template #semDna>
  <div class="dna-heranca-vazio">
    <span class="dna-heranca-vazio__simbolo">
      <i class="fas fa-dna" aria-hidden="true"></i>
    </span>
    <p class="dna-heranca-vazio__titulo">Este SKU não está vinculado a nenhum DNA</p>
    <p class="dna-heranca-vazio__texto">
      Sem DNA, o item não herda expectativas e não é avaliado pelo PLM 3Vs. É um estado permanente
      e legítimo — vincule um DNA quando quiser acompanhar este produto.
    </p>
    <button
      *ngIf="podeEditar"
      type="button"
      class="dna-heranca-vazio__acao"
      (click)="vincular.emit()"
    >
      Vincular a um DNA
    </button>
  </div>
</ng-template>
